import useFetchIam from '../../api/useFetchIam';

type Props = {
  onProfileEdit: () => void;
  deleteOpen: () => void;
  onMergeOpen?: () => void;
};

export default function CompaniesProfileMenu({ onProfileEdit, deleteOpen, onMergeOpen }: Props) {
  const { data: iam } = useFetchIam();
  const isAdmin = iam?.current_user?.is_admin;

  return (
    <div className="w-[180px] rounded bg-white shadow-[0px_0px_12px_0px_#00000033]">
      <button
        type="button"
        className="flex h-xxl w-full items-center justify-center text-sm hover:opacity-60"
        onClick={onProfileEdit}
      >
        企業情報を編集する
      </button>
      {isAdmin && onMergeOpen && (
        <button
          type="button"
          className="flex h-xxl w-full items-center justify-center text-sm hover:opacity-60"
          onClick={onMergeOpen}
        >
          他の企業へ統合する
        </button>
      )}
      {isAdmin && (
        <button
          type="button"
          className="flex h-xxl w-full items-center justify-center text-sm text-danger hover:opacity-60"
          onClick={deleteOpen}
        >
          企業情報を削除する
        </button>
      )}
    </div>
  );
}
